import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import Header from '../../components/Header'
import hero from '../../images/whats-new__hero.jpg'
import Articles from '../../components/News/Articles'

const Page = () => (
  <Fragment>
    <Helmet
      title="What's New | Who We Are"
      // meta={[{ name: 'description', content: '' }]}
    />
    <Header hero={hero}>
      <h1 className="t-hero">What's New</h1>
    </Header>
    <main id="content" style={{ height: "100%"}}>
      <div className="o-container">
        <ul className="c-breadcrumbs mt30">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/who-we-are">Who We Are</Link>
          </li>
          <li>
            <Link to="/who-we-are/whats-new" activeClassName="is-active">
              What's New
            </Link>
          </li>
        </ul>
      </div>
      <Articles />
    </main>
  </Fragment>
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/who-we-are/whats-new.js